//
//
//
//
//
//
//
//
//

export default {

}



// WEBPACK FOOTER //
// ./src/components/common/no-data.vue